// The live domain uses its existing Netlify Forms receiver; Sites uses its Worker.
export const isNetlifyProduction = host => ["sercefinansow.pl", "www.sercefinansow.pl"].includes(host);
export const contactEndpointForHost = host => isNetlifyProduction(host) ? "/" : "/api/contact";
export const contactResponseAccepted = async (response, host) => {
  if (!response.ok) return false;
  if (isNetlifyProduction(host)) return true;
  const result = await response.json();
  return result.ok === true;
};
